import React from "react";
import { withStyles, FormControl, InputLabel, Select } from "material-ui";
import { Clear, Check } from "@material-ui/icons";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";

import customInputStyleRegister from "assets/jss/material-kit-react/components/customInputStyleRegister.jsx";

function CustomInputSelectDeadline({ ...props }) {
  

  const {
    classes,
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    success
  } = props;

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });
  const formControlClasses = classNames({
    [classes.formControl]: true,
    [classes.formControlLabel]: labelText !== undefined,
    [formControlProps.className]: formControlProps.className !== undefined
  });


  return (
    <FormControl
      {...formControlProps}
      className={formControlClasses}
    >
      {labelText !== undefined ? (
        <InputLabel
          className={classes.labelRoot + " " + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Select
        native
        value={props.value}
        onChange={props.onChange}
        {...inputProps}
        id={id}
        >
        <option value="" />
            <option value='Immediately'>Immediately</option>
            <option value='1 to 3 Months'>1 to 3 Months</option>
            <option value='3 to 6 Months'>3 to 6 Months</option>
            <option value='1 Year'>1 Year</option>
            <option value='Not sure'>Not sure</option>
        </Select>
      {error ? (
        <Clear className={classes.feedback + " " + classes.labelRootError} />
      ) : success ? (
        <Check className={classes.feedback + " " + classes.labelRootSuccess} />
      ) : null}
    </FormControl>
  );
}

CustomInputSelectDeadline.propTypes = {
  classes: PropTypes.object.isRequired,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  value: PropTypes.node,
  white: PropTypes.bool
};

export default withStyles(customInputStyleRegister)(CustomInputSelectDeadline);



// WEBPACK FOOTER //
// ./src/components/CustomInput/CustomInputSelectDeadline.jsx